import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ITrackContractsTime } from './types';

export const useGetTrackContractFuture = (TrackId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackContractsTime, DefaultError>({
    queryKey: ['track-contract-future', TrackId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Track/Contract/Future`,
        params: { TrackId },
      });

      return responseHandler(response, {
        groupName: `useGetTrackContractFuture - ${TrackId}`,
      });
    },
  });
};

export const useGetTrackContractHistory = (TrackId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ITrackContractsTime, DefaultError>({
    queryKey: ['track-contract-history', TrackId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Track/Contract/History`,
        params: { TrackId },
      });

      return responseHandler(response, {
        groupName: `useGetTrackContractHistory - ${TrackId}`,
      });
    },
  });
};
